const s = ":host{display:block}:host(:not([active])){display:none !important}:host([active]){display:block}.sl-tab-content{display:none;box-sizing:border-box;padding:var(--sl-tab-content-padding,var(--sl-spacing-4))}.sl-tab-content--active{display:flex;flex-direction:column;animation:fadeIn var(--sl-transition-fast)}:host([no-padding]) .sl-tab-content,.sl-tab-content--no-padding{padding:0 !important}@keyframes fadeIn{from{opacity:0}to{opacity:1}}";
class a extends HTMLElement {
  static get observedAttributes() {
    return ["name", "active", "no-padding"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._render();
  }
  connectedCallback() {
    this._updateContent();
  }
  attributeChangedCallback(t, e, n) {
    e !== n && this._updateContent();
  }
  get name() {
    return this.getAttribute("name");
  }
  set name(t) {
    t ? this.setAttribute("name", t) : this.removeAttribute("name");
  }
  get active() {
    return this.hasAttribute("active");
  }
  set active(t) {
    t ? this.setAttribute("active", "") : this.removeAttribute("active");
  }
  _updateContent() {
    this._container && (this._container.className = this._getContentClasses(), this._container.setAttribute("role", "tabpanel"), this._container.setAttribute("tabindex", "0"), this._container.setAttribute("aria-hidden", this.hasAttribute("active") ? "false" : "true"), this.name && (this._container.id = `tab-content-${this.name}`));
  }
  _getContentClasses() {
    const t = ["sl-tab-content"];
    return this.hasAttribute("active") && t.push("sl-tab-content--active"), t.join(" ");
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${s}</style>
      <div
        part="base"
        class="${this._getContentClasses()}"
        role="tabpanel"
        tabindex="0"
        aria-hidden="${this.hasAttribute("active") ? "false" : "true"}"
        ${this.name ? `id="tab-content-${this.name}"` : ""}
      >
        <slot></slot>
      </div>
    `, this._container = this._shadow.querySelector("div");
  }
}
typeof customElements < "u" && !customElements.get("sl-tab-content") && customElements.define("sl-tab-content", a);
export {
  a as SlTabContentElement
};
//# sourceMappingURL=sl-tab-content.js.map
